"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rgs_check_1 = require("../icons/rgs-check");
exports.default = rgs_check_1.RGSCheck;
